import { NgModule } from '@angular/core';

import { HisInputSharedModule } from './his-input-shared.module';

/**
 * The core module for the generic search.
 */
@NgModule( {
    imports: [
        HisInputSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisInputSharedModule
    ]
} )

export class HisInputCoreModule {

}
